import React, { Component } from 'react';
import { ReactComponent as FilterIcon } from 'Icons/filter-new.svg';
import { ReactComponent as DownloadIcon } from 'Icons/download-new.svg';
import { ReactComponent as UploadIcon } from 'Icons/upload.svg';
import Upload from 'Components/Upload/index';
import Cx from 'classnames';

class TripTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {
                search: '',
                limit: 1000,
                offset: 0
            }
        }
    }

    onChangeSearch = (e) => {
        this.setState({
            filter: {
                search: e.target.value
            }
        }, () => {
            this.props.fetchTrips(this.state.filter);
        })
    }

    render() {
        const { filter } = this.state;
        const { rfqType } = this.props;

        return (
            <div className='flex flex-between pv-10 ph-20 ht-60 border-bottom-light'>
                <div className='flex col-2'>
                    <div className='header pt-10'>Trip Details</div>
                    <div>
                        <input 
                            placeholder={`Search`} 
                            type="text" 
                            className="ml-20 wt-200 ht-38 search searchBorder"
                            value={filter.state}
                            onChange={this.onChangeSearch}
                        />
                    </div>
                    <FilterIcon />
                </div>
                <div className='col-2'>
                    {![13,14,15].includes(rfqType) && <>
                        <button className='tripButtons text-color curP' onClick={this.props.downloadTrips}> <DownloadIcon className='mr-5'/> Download Template</button>
                        <Upload onChange={(file) => this.props.uploadTrips(file)} value="Upload File">
                            <button className='tripButtons text-color ml-10'> 
                                <UploadIcon className='mr-5' /> Upload Excel
                            </button>
                        </Upload>
                    </>}
                    <button className={Cx('tripButtons text-color-filled-bg ml-10', {
                        'fRight': [13,14,15].includes(rfqType)
                    })} onClick={this.props.onClickAddTrip}> + Add New Trip</button>
                </div>
            </div>
        )
    }
}

export default TripTableHeader;

